module.exports = __webpack_public_path__ + "static/media/Apple.c1c39df0.png";